import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaQuestionCircle } from 'react-icons/fa'; // Example using FontAwesome
  
  export const renderTooltipMinReturns = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Market Volatility may push Scheme Value downwards. The summarization given below is based on the <b>probable (negative) trends & predicted Min. returns</b> by the Scheme. In such Markets, prediction is highlighted as "-1 - Lower ...." if pNAV indicate - probable dip in Scheme value of less than 15%.
    </Tooltip>
  );
  export const renderTooltipMaxReturns = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Market Volatility may swing Scheme Values. The summarization given below is based on the <b>probable trends & predicted Max. returns</b> by the Scheme. In such Markets, prediction may also be highlighted as "-1 - Lower ...." if pNAV indicate - probable dip in Scheme value of less than 15%.
    </Tooltip>
  );
  export const renderTooltipCurrentRank = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Prediction based Rank - using prediction analysis and historical performance available as of "Last Actual NAV Date". Value is '111111', when pNAV is not calculated due to limited data availability.
    </Tooltip>
  );
  export const renderTooltipLastRank = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      'Current Rank' during last prediction cycle. Value is '111111', when pNAV is not calculated in the earlier cycle due to limited data availability.
    </Tooltip>
  );

  export const renderTooltipMaxProbable = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Considering market Volatility and <b>current trends</b>, this is High (probable) NAV, predicted at the "pNAV calculated for" date. Value is '-SKIPPED-', if high deviation.
    </Tooltip>
  );
  export const renderTooltipMeanProbable = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Considering market Volatility and <b>current + earlier trends</b>, this is Mean NAV, predicted at the "pNAV calculated for" date. Value is '-SKIPPED-', if high deviation.
    </Tooltip>
  );
  export const renderTooltipPeakProbable = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Considering market Volatility and <b>current + earlier trends</b>, this is Max NAV, predicted at the "pNAV calculated for" date. Value is '-SKIPPED-', if high deviation.
    </Tooltip>
  );

  export const renderTooltipPNAVvolatility = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
      Refers to Market Volatility and Risk based on <b>current + earlier trends</b>
    </Tooltip>
  );

  export const renderTooltipLaunchGroup = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Based on Launch Date or 1'st Public availability of the Scheme 
    </Tooltip>
  );

  export const renderTooltipCAGRGroup = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Based on Compound Annual Growth Rate (CAGR) Percentage calculated using available daily NAVs and earliest available NAV. 
    </Tooltip>
  );

  export const renderTooltipCAGRRank = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Ranking based on Compound Annual Growth Rate (CAGR) Percentage which is calculated using available daily NAVs. <b>Value 0 indicates that the scheme is not ranked in this cycle</b> due to certain limitation.
    </Tooltip>
  );


  export const renderTooltipAnnualizedReturns = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Annual Returns in 1 year calculated using available daily NAVs of last approx.ly 365 days. 
    </Tooltip>
  );

  export const renderTooltip180DaysReturns = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Annual Returns as per 180 Days NAV Data calculated using available daily NAVs of last approx.ly 180 days. 
    </Tooltip>
  );

  export const renderTooltipSchemeName = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Click to view more information on Scheme Past & Predicted Performance 
    </Tooltip>
  );

  export const renderTooltipCagrRank = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Ranking based on CAGR (historical performance) as of "Last Actual NAV Date"
    </Tooltip>
  );

  export const renderTooltipStability = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       Based on available information of AUM and launch Date. 
    </Tooltip>
  );

  export const renderTooltipPredAnalysis = (compactHeader) => (
    <Tooltip id={`tooltip-${compactHeader}`}>
       <b>Disclaimer</b>: Analysis indicator for the scheme is mostly based on the prediction but, in few cases past performance is also considered. Consult your financial adviser before making any financial decisions.
    </Tooltip>
  );

  export const renderHeaderAndTooltip = (headerText, toolTipFunc, compactHeader, getSortIndicator, thisSortField, isAsc, sortSuffix) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
      <OverlayTrigger
        placement="left"
        delay={{ show: 250, hide: 400 }}
        overlay={toolTipFunc(compactHeader)}
      >
        <span style={{ cursor: 'help', color: '#6c757d' }}>
          <FaQuestionCircle />
        </span>
      </OverlayTrigger>
      {headerText}&nbsp;{getSortIndicator ? (sortSuffix ? getSortIndicator(thisSortField, isAsc, sortSuffix) : getSortIndicator(thisSortField)):""}
    </div>
  );

//   const renderTooltipMinReturns = (props) => (
//     <Tooltip id="button-tooltip" {...props}>
//       Considering market Volatility, summarization below indicates worst probable scenario at "pNAV calculated for" date. Predicted value of Min. pNAV is not shared, but just probable worst case scenario is highlighted.
//     </Tooltip>
//   );

//   const renderTooltipMaxProbable = (props) => (
//     <Tooltip id="button-tooltip" {...props}>
//       Considering market Volatility and current trends, this is High (probable) NAV predicted at the "pNAV calculated for" date
//     </Tooltip>
//   );

//   const renderTooltipPeakProbable = (props) => (
//     <Tooltip id="button-tooltip" {...props}>
//       Considering market Volatility and current + earlier trends, this is Max NAV predicted at the "pNAV calculated for" date
//     </Tooltip>
//   );

  // Utility to detect negative value
  export const isNegative = val => {
    if (typeof val === 'string') return val.trim().startsWith('-');
    if (typeof val === 'number') return val < 0;
    return false;
  };

  export const trendingDown = val => {
    if (typeof val === 'string') {
       const newVal = val.trim();
       if (newVal.startsWith('00 - Low') || newVal.startsWith('-1 - Low')) {
          return true;
       }
    }    
    return false;
  };

  /****
   ### Top HTML Colors for Volatility          
    #FF0000 (Red): Highest alert, extreme volatility. 
    #FF4500 (OrangeRed): Intense volatility, high market risk, say Quackit Tutorials.
    #FF8C00 (DarkOrange): Moderate-to-high volatility.
    #CD5C5C (IndianRed): Subtle alert color.
    #F08080 (LightCoral): Used for lower-level warning,
    #FFFF00 (Yellow)

   */
  export const getVolatilityColor = val => {
    if (typeof val === 'string') {
        if (val.includes('Higher')) {
          return '#FF4500';  // Red
        } else if (val.includes('High')) {
          return '#CD5C5C'; // IndianRed
        }
    }    
    return 'inherit';
  }

  export const getPredAnalysisColor = val => {
    let backgroundColor = '#fff4e6';
    let fontWeight = 'bold';
    let color = 'inherit'
    if (typeof val === 'string') {
        if (val.includes('Red')) {
            color = '#CD5C5C'; // Indian Red
        } else if (val.includes('Orange')) {
            color = '#FF8C00'; // DarkOrange
        } else if (val.includes('Yellow')) {
            backgroundColor = '#999ea3';
            color = '#F6BE00'; // Dark Yellow
        } else {
            fontWeight = 'normal';
        }
    }
    return {
            backgroundColor: backgroundColor,
            color: color,
            fontWeight: fontWeight
          } 
  }

  export const trendingColor = val => {
    if (typeof val === 'string') {
       const newVal = val.trim();
       if (newVal.startsWith('00 - Low')) {
        return  "Firebrick";
       } else if (newVal.startsWith('-1 - Low')) {
          return "Maroon";
       } else if (newVal.startsWith('-2 - Limited')) {
          return "#C76E00"
       } else if (newVal.startsWith('11 - High')) {
          return "#FF4D00"
       }
    }    
    return 'inherit';
  };

  export const trendingColor2 = val => {
    if (typeof val === 'string') {
       const newVal = val.trim();
       if (newVal.startsWith('-1 - Low')) {
          return "Maroon";
       } else if (newVal.startsWith('-2 - Limited')) {
          return "#C76E00"
       } else if (newVal.startsWith('11 - High')) {
          return "#FF4D00"
       }
    }    
    return 'inherit';
  };

  export const nameStyle = (minValMsg, maxValMsg, actual1yr, volatility, isSelected) => {
    let myColor = 'inherit';

    myColor = trendingColor2(minValMsg);
    if (myColor === 'inherit') {
      myColor = trendingColor2(maxValMsg);
    }
    if (myColor === 'inherit') {
      if (isNegative(actual1yr) ) {
        myColor = 'red';
      }
    }
    if (!isSelected) {
      return {
        color: myColor
      }
    } else {
      if (myColor === 'inherit') {
        myColor = '#198754'  // default Bootstrap 5 success color
      }
      return {
        fontWeight: 'bold', // or style={{ fontWeight: 700 }}
        color: myColor
      }
    }
  };